// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-details {
  height: 100%;
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  font-family: 'Roboto', sans-serif;
}

.message-details-block {
  width: 100%;
  border-bottom: 1px solid rgb(220, 220, 220);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.message-details-block-item {
  width: calc(100% - 16px);
  padding: 20px 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.message-details-block.no-bottom-border {
  border-bottom: none;
}

.message-details-attachment {
  font-size: 14px;
  line-height: 16px;
  overflow-wrap: break-word;
  word-break: break-word;
  color: rgb(0, 0, 0);
  margin-bottom: 8px;
}

.message-details-date {
  font-size: 14px;
  line-height: 16px;
  overflow-wrap: break-word;
  word-break: break-word;
  color: rgb(0, 0, 0);
}

.message-details-id {
  font-size: 12px;
  color: rgb(151, 151, 151);
  line-height: 16px;
}

.message-details-block-header {
  width: 100%;
  padding: 16px;
}

.message-details-block-header.clickable {
  cursor: pointer;
}

.message-details-list-title {
  font-size: 14px;
  color: rgb(151, 151, 151);
  min-height: 0px;
}

.message-details-count {
  color: rgb(222, 72, 88);
}

/* Redaction block styling */
.message-details-redaction-block {
  background-color: rgba(231, 76, 60, 0.05);
  border-top: 1px solid rgba(231, 76, 60, 0.2);
  border-bottom: 1px solid rgba(231, 76, 60, 0.2);
}

.message-details-redaction-block .message-details-block-header {
  background-color: rgba(231, 76, 60, 0.1);
}

.message-details-redaction-block .message-details-list-title {
  color: #e74c3c;
  font-weight: 600;
}

.message-details-redaction-info {
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.message-details-redaction-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.message-details-redaction-label {
  font-size: 12px;
  color: rgb(151, 151, 151);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.message-details-redaction-value {
  font-size: 14px;
  color: rgb(0, 0, 0);
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/RightSidebar/MessageDetails.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,yCAAyC;EACzC,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".message-details {\n  height: 100%;\n  width: 100%;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  font-family: 'Roboto', sans-serif;\n}\n\n.message-details-block {\n  width: 100%;\n  border-bottom: 1px solid rgb(220, 220, 220);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.message-details-block-item {\n  width: calc(100% - 16px);\n  padding: 20px 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.message-details-block.no-bottom-border {\n  border-bottom: none;\n}\n\n.message-details-attachment {\n  font-size: 14px;\n  line-height: 16px;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  color: rgb(0, 0, 0);\n  margin-bottom: 8px;\n}\n\n.message-details-date {\n  font-size: 14px;\n  line-height: 16px;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  color: rgb(0, 0, 0);\n}\n\n.message-details-id {\n  font-size: 12px;\n  color: rgb(151, 151, 151);\n  line-height: 16px;\n}\n\n.message-details-block-header {\n  width: 100%;\n  padding: 16px;\n}\n\n.message-details-block-header.clickable {\n  cursor: pointer;\n}\n\n.message-details-list-title {\n  font-size: 14px;\n  color: rgb(151, 151, 151);\n  min-height: 0px;\n}\n\n.message-details-count {\n  color: rgb(222, 72, 88);\n}\n\n/* Redaction block styling */\n.message-details-redaction-block {\n  background-color: rgba(231, 76, 60, 0.05);\n  border-top: 1px solid rgba(231, 76, 60, 0.2);\n  border-bottom: 1px solid rgba(231, 76, 60, 0.2);\n}\n\n.message-details-redaction-block .message-details-block-header {\n  background-color: rgba(231, 76, 60, 0.1);\n}\n\n.message-details-redaction-block .message-details-list-title {\n  color: #e74c3c;\n  font-weight: 600;\n}\n\n.message-details-redaction-info {\n  width: 100%;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.message-details-redaction-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.message-details-redaction-label {\n  font-size: 12px;\n  color: rgb(151, 151, 151);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 500;\n}\n\n.message-details-redaction-value {\n  font-size: 14px;\n  color: rgb(0, 0, 0);\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
